<!-- src/components/TrialModalView.vue -->

<template>
    <div>
        <vue-modal 
            v-if="hasTrialExpired" 
            :allow-close="false" 
            class="trial-modal">
            <div slot="body">
                <div class="trial-cone"></div>
                <h3>Your Free Trial Has Expired...</h3>
                <p>Sign up for a full subscription to continue using Construct-A-Lead.</p>
            </div>
            <div slot="footer">
              <vue-button
                  type="green large"
                  @click="$router.push({ path: '/Me/Subscription' })">Sign Up</vue-button>
                <vue-button
                    type="large"
                    @click="routeToScheduleDemo">Schedule a demo</vue-button>
              <vue-button
                  type="large"
                  @click="routeToHomepage">Home page</vue-button>
            </div>
        </vue-modal>
    </div>
</template>

<script>

import VueModal from '../Shared/VueModal.vue';
import VueButton from '../Shared/VueButton.vue';
import auth from "../../services/Client/Auth";

export default {    
    
    components: { VueModal, VueButton },
    
    data () {
        return {
            hasTrialExpired: false
        }
    },
    
    methods: {
        
        setAccountStyle (route) {
            
            if (route.meta && route.meta.user) {
                this.hasTrialExpired = false
            }
            else {
                this.hasTrialExpired = this.$root.$data.auth.hasTrialExpired();
            }
        },
        routeToScheduleDemo() {
            window.location.href = "https://www.constructalead.com/schedule-a-demo";
        },
        routeToHomepage() {
          this.$root.$data.auth.logout();
          window.location.href = 'https://www.constructalead.com/';
        }
    },
    
    watch: {
        '$root.$data.auth.user.subscription.remaining_projects': {
            handler: function (val, oldVal) {
              // If the remaining projects is 0, trigger. But do not trigger when we go from 1 to 0.
              if (val === 0 && oldVal === 0) {
                this.setAccountStyle(this.$route);
              }
            },
            deep: true
        },
        '$route': function(route) {
            this.setAccountStyle(route);
        },
    }
}
</script>

<style>
.trial-modal {
    text-align: center;
}

.trial-modal h3 {
    font-weight: 500;
    font-size: 20px;
    color: #4A4A4A;
}

.trial-modal p {
    font-size: 14px;
    color: #969696;
    padding: 0px 50px 20px;
}

.trial-modal .trial-cone {
    background: url('/images/CAL-Logo-footer.png');
    background-size: 100% 100%;
    width: 69px;
    height: 90px;
    display: inline-block;
}
</style>
